import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from "../../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../../form-controls/services/context-interaction.service";


@Component({
    selector: 'app-bulk-well-transfer-parser-data-config',
    templateUrl: './bulk-well-transfer-parser-data-config.component.html',
    styleUrls: ['./bulk-well-transfer-parser-data-config.component.scss'],
    standalone: false
})
export class BulkWellTransferParserDataConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = "BulkWellTransferParserDataConfigComponent";


    get storeAPIs(): string {
        if (!this.componentData) this.componentData = { config: {} };
        if (!this.componentData.config) this.componentData.config = { storeAPIs: "" };
        if (!this.componentData.config.storeAPIs) this.componentData.config.storeAPIs = "";
        return this.componentData.config.storeAPIs;
    }

    set storeAPIs(value: string) {
        if (!this.componentData) this.componentData = { config: {} };
        if (!this.componentData.config) this.componentData.config = { storeAPIs: value };
        if (!this.componentData.config.storeAPIs) this.componentData.config.storeAPIs = value;
        this.componentData.config.storeAPIs = value;
    }


    constructor(svc: ContextInteractionService) { super(svc); }

    ngOnInit() {
      
    }

}
